import styled from '@emotion/styled';
import { Avatar, Box } from '@mui/material';

export const CommonModalWrapperBox = styled(Box)({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  backgroundColor: 'white',
  padding: '24px',
  borderRadius: '16px',
  outline: 'none',
  border: 'none'
});

export const CommonModalContentBox = styled(Box)({ display: 'flex', flexDirection: 'column', gap: '2px', width: '100%' });

export const CommonModalActionsBox = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%',
  marginTop: '16px',
  gap: '16px'
});

export const ProfilePageBox = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
  gap: '48px',
  flex: '1 0 0',
  alignSelf: 'stretch',
  borderRadius: '10px',
  background: '#FFF'
});

export const ProfilePictureAvatar = styled(Avatar)<{ width?: number | string; height?: number | string }>(
  ({ width = 139, height = 137 }) => ({
    width,
    height,
    borderRadius: '100%',
    background: '#F5F5FE',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    color: '#BEBAD4'
  })
);
